import { useState } from "react"
import { login } from "@/lib/api"
import PulseLogo from "@/components/PulseLogo"

interface Props {
  onSuccess: (email: string) => void
}

export default function PulseLogin({ onSuccess }: Props) {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError("")
    setLoading(true)
    const result = await login(email, password)
    setLoading(false)
    if (result.ok) {
      onSuccess(result.email || email)
    } else {
      setError(result.error || "Login failed")
    }
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen px-6">
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center space-y-2">
          <PulseLogo size={56} className="mx-auto" />
          <h1 className="text-2xl font-semibold text-white">Pulse</h1>
          <p className="text-sm text-gray-500">CloakAI Operations</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs text-gray-400 uppercase tracking-wider block mb-1.5">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full px-3 py-2.5 rounded-lg bg-card border border-border text-sm text-gray-200 placeholder-gray-600 focus:outline-none focus:ring-1 focus:ring-accent/50 focus:border-accent/50 transition-colors"
              placeholder="you@company.com"
              autoComplete="email"
              autoFocus
            />
          </div>

          <div>
            <label className="text-xs text-gray-400 uppercase tracking-wider block mb-1.5">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-3 py-2.5 rounded-lg bg-card border border-border text-sm text-gray-200 placeholder-gray-600 focus:outline-none focus:ring-1 focus:ring-accent/50 focus:border-accent/50 transition-colors"
              placeholder="Your password"
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div className="text-xs text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 rounded-lg bg-accent hover:bg-accent/90 text-white text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <div className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Signing in...
              </span>
            ) : (
              "Sign in to Pulse"
            )}
          </button>
        </form>

        <p className="text-center text-xs text-gray-600">
          Uses your CloakAI account
        </p>
      </div>
    </div>
  )
}
